<div class="list-questions-item-wrapper" [class.hide]="!firstInBlock$() && inBlock$()">
  @if (firstInBlock$()) {
    <empathy-list-block-questions-item [block]="firstInBlock$()" [activeQuestionId]="activeQuestionId()" (activate)="activate.emit($event)" />
  } @else if (!inBlock$()) {
    <div class="list-questions__list-row margin-bottom">
      <empathy-list-question-item
        [id]="'anchor__' + question().id"
        [active]="activeQuestionId() === question().id"
        [isFirst]="isFirst$()"
        [isLast]="isLast$()"
        [movePositionAllowed]="movePositionAllowed$()"
        [question]="question()"
        (activate)="onActivate($event)"
      ></empathy-list-question-item>
    </div>
  }
</div>
